import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() { }

  url(caminho: string, servico: string = 'saude', protocolo: string = 'https') {
    if(environment.production) {
      if(servico == 'whatsmyversion') {
        return `${protocolo}://whatsmyversion.smosc.com.br/${caminho}`;
      }
      
      return `${protocolo}://api.${servico}.smosc.com.br/${caminho}`;
    } else {
      if(servico == 'whatsmyversion') {
        return `${protocolo}://whatsmyversion.smosc.localhost.com.br/${caminho}`;
      }

      return `${protocolo}://api.${servico}.localhost.smosc.com.br/${caminho}`;
    }
  }
}
